export default __webpack_public_path__ + "static/qr-9d5bd0c1fc2baa02e7529021929a9e22.png";